<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_event_form_editTitle')
        : $t('label_essweb_event_form_viewTitle')
    "
    widthClass="max-1000"
    :editBtn="!iSEdited"
    pad="0"
    :initData="eventData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'event_business_name',
      'event_business_code',
      'event_business_description',
      'start_utc_time',
      'end_utc_time',
      'event_type_uuid',
      'event_property_group_uuid',
      'remarks',
    ]"
    @edit="iSEdited = true"
    delBtn
    @delete="
      $confirmDo($t('label_essweb_event_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row align="center" justify="start">
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_event_list_eventTypeLabel")
                }}</v-sheet>
                <v-autocomplete
                  :items="EventType"
                  item-text="event_type_name"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  item-value="uuid"
                  :disabled="true"
                  single-line
                  @change="onTypeChange"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  v-model="eventData.event_type_uuid"
                  :label="$t('label_essweb_event_list_eventTypeLabel')"
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="eventData.event_business_name"
                  @change="
                    (valueArr) => {
                      eventData.event_business_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_event_form_eventNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  v-model="eventData.event_business_code"
                  maxlength="20"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  maxlength="500"
                  :readonly="!iSEdited"
                  :bindData="eventData.event_business_description"
                  @change="
                    (valueArr) => {
                      eventData.event_business_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_event_form_eventDescriptionLabel')"
                />
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <TimePicker
                  isRequire
                  showDay
                  :max="eventData.end_utc_time"
                  :value="eventData.start_utc_time"
                  :defaultTime="eventData.start_utc_time"
                  :disable="!iSEdited"
                  :label="$t('label_essweb_event_form_eventStartTimeLbel')"
                  placeholder="--:--"
                  @change="
                    (time) => {
                      eventData.start_utc_time = time;
                    }
                  "
                />
              </v-col>
              <!-- <v-col md="3" class="mt-n5">
                Time Zone
                <v-autocomplete
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                  dense
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  placeholder="time zone"
                  v-model="eventData.start_time_time_zone"
                  :filled="iSEdited"
                  single-line
                  :readonly="!iSEdited"
                >   <template v-slot:no-data>
                <noContent />
              </template></v-autocomplete>
              </v-col>-->
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <TimePicker
                  isRequire
                  isEnd
                  showDay
                  :min="eventData.start_utc_time"
                  :value="eventData.end_utc_time"
                  :defaultTime="eventData.end_utc_time"
                  placeholder="--:--"
                  :label="$t('label_essweb_event_form_eventEndTimeLabel')"
                  :disable="!iSEdited"
                  @change="
                    (time) => {
                      eventData.end_utc_time = time;
                    }
                  "
                />
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12" class="mt-n5">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_event_form_timeZoneLabel")
                }}</v-sheet>
                <v-select
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                  dense
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  :placeholder="$t('label_essweb_event_form_timeZoneLabel')"
                  :filled="iSEdited"
                  v-model="eventData.end_time_time_zone"
                  single-line
                  :readonly="!iSEdited"
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-form ref="form2">
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12" offset-md="0">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_event_form_eventPropertyGroupLabel")
                }}</v-sheet>
                <v-select
                  :items="EventGroup"
                  item-text="event_property_group_name"
                  item-value="uuid"
                  @change="onGroupChange"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  :filled="iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  v-model="eventData.event_property_group_uuid"
                  single-line
                  :readonly="!iSEdited"
                  :label="$t('label_essweb_event_form_eventPropertyGroupLabel')"
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <PropertyList
                  :items="desserts"
                  v-if="desserts.length"
                  :listdata="PropertyListData"
                  :canEdit="false"
                  @view="
                    (obj) => {
                      viewProperty = true;
                      toEditProperty(obj);
                    }
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </template>
      </Taber>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <EditMappingPopup2
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        :curGroupId="eventData.event_property_group_uuid"
        :view="viewProperty"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import EditMappingPopup2 from "@/Page/EssAdmin/Event/EventPropertyGroup/components/EditMappingPopup2.vue";
import { mapGetters } from "vuex";
export default {
  name: "editEvent",
  components: {
    EditMappingPopup2,
  },
  computed: {
    curType() {
      return this.eventData.event_type_uuid;
    },
    ...mapGetters(["companyLang", "staticZone"]),
    EventType() {
      return this.$getSelectTrans(this.EventTypeData, "event_type_name");
    },
    EventGroup() {
      return this.$getSelectTrans(
        this.EventGroupData,
        "event_property_group_name"
      );
    },
  },
  watch: {
    curType(type) {
      const that = this;
      if (type) {
        this.EventTypeData.forEach(function (item) {
          if (item.uuid == type) {
            that.curTable = item.table_name;
          }
        });
      }
    },
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.curTable = this.page_params.table;
    this.getEventType();
    this.getEventGroup();
    this.getEventDetailByUuid();
  },
  data() {
    return {
      isChanged: false,
      iSEdited: true,
      page_params: null,
      PropertyListData: null,
      showMappingPopup: false,
      PropertyData: null,
      viewProperty: true,
      curTab: "tab-1",
      taber: [
        "label_essweb_event_form_step_generalLabel",
        "label_essweb_event_form_step_propertyGroupLabel",
      ],
      showPropertyDialog: false,
      eventData: {
        uuid: "",
        event_business_name: "",
        event_business_code: "",
        event_business_description: "",
        start_utc_time: "",
        start_time_time_zone: 0,
        end_utc_time: "",
        end_time_time_zone: 0,
        event_type_uuid: "",
        event_property_group_uuid: "",
        remarks: "",
      },
      EventTypeData: [],
      desserts: [],
      EventGroupData: [],
    };
  },

  methods: {
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            this.$router.back();
          }
        });
      else {
        this.$router.back();
      }
    },

    onTypeChange: function (type) {
      const that = this;
      if (type) {
        this.EventTypeData.forEach(function (item) {
          if (item.uuid == type) {
            that.curTable = item.table_name;
          }
        });
      }
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    onGroupChange: function (uuid) {
      this.getPropertyList(uuid);
    },
    getPropertyList: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property",
        url: "/event-property/get-event-property-list/",
        data: {
          event_property_group_uuid: uuid,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    getEventType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/get-event-type-list/",
        data: { event_category_uuid: "att" },
      }).then((res) => {
        res.data.map((item) => {
          if (item.table_name) {
            that.EventTypeData.push(item);
          }
        });
      });
    },
    getEventGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/get-event-property-group-list/",
      }).then((res) => {
        that.EventGroupData = res.data;
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: this.curTable,
        url: "/event/delete-event-table/",
        data: { uuids: this.page_params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t("message_essweb_event_list_deleteEventSuccessLabel"),
          type: "success",
        });
        that.toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: this.curTable,
        url: "/event/update-event-table/",
        data: {
          uuid: this.page_params.id,
          event_business_name: this.$transCommonLangKey(
            this.eventData.event_business_name,
            this.eventData.event_business_name_save
          ),
          event_business_description: this.$transCommonLangKey(
            this.eventData.event_business_description,
            this.eventData.event_business_description_save
          ),
          event_business_code: this.eventData.event_business_code,
          start_utc_time: this.eventData.start_utc_time,
          start_time_time_zone: this.eventData.end_time_time_zone,
          end_utc_time: this.eventData.end_utc_time,
          end_time_time_zone: this.eventData.end_time_time_zone,
          // event_type_uuid: this.eventData.event_type_uuid,
          event_property_group_uuid: this.eventData.event_property_group_uuid,
          remarks: this.eventData.remarks,
        },
      }).then((res) => {
        that.toBack(); //回到不能编辑状态
        that.$showMessage({
          text: that.$t("message_essweb_event_list_updateEventSuccessLabel"),
          type: "success",
        });
      });
    },
    getEventDetailByUuid: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: this.page_params.table,
        url: "/event/get-event-details/",
        data: { uuid: this.page_params.id },
      }).then((res) => {
        res.data["event_business_name_save"] = res.data.event_business_name;
        res.data.event_business_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.event_business_name
        );
        res.data["event_business_description_save"] =
          res.data.event_business_description;
        res.data.event_business_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.event_business_description
        );
        if (res.data.event_type_uuid) {
          that.onTypeChange(res.data.event_type_uuid);
        }
        if (res.data.event_property_group_uuid) {
          that.getPropertyList(res.data.event_property_group_uuid);
        }
        that.eventData = res.data;
      });
    },
  },
};
</script>
